import request, { appendApiUrl } from '@/utils/request'
import { deleteEmpty } from './common.js'

// 首页查询基础配置接口
export const fetchBasicConfig = (options = {}) => {
  return request.postJson(
    {
      url: appendApiUrl('/home-page/query/basic-config'),
      data: { ...deleteEmpty(options) },
    },
    {
      showLoading: false,
      showErrorToast: false,
    }
  )
}

// 首页红包活动
export const withoutActivity = (options = {}) => {
  return request.postJson(
    {
      url: appendApiUrl('/activity/save/coupon/without/activity'),
      data: { ...deleteEmpty(options) },
    },
    {
      showLoading: false,
      showErrorToast: false,
    }
  )
}
